module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"addAContact":"Add a contact (default)","searchError":"Something went wrong while searching, please try again."}}')
  delete Component.options._Ctor
}
